<template>
    <v-container fluid>
    <!-- inicio de cambiar de rancho -->
    <v-row class="pa-0 ma-0 align-center"
           justify="center"
           no-gutters>
    <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
      <ChangeRanch
        :paddock="paddockSelected"
        :paddocks="currentPaddocks">
      </ChangeRanch>
    </v-col>
    </v-row>
    <!-- fin de cambiar de rancho -->

    <!-- inicio de texto principal -->
    <v-row class="my-3 px-2 smart-title-2 home-title-container-mobile"
           no-gutters>
      <v-col cols="12" class="d-flex align-center justify-center">
        <div class="unselectable" style="text-align:center">Bienvenido -usuario- Elige una tarea para comenzar </div>
      </v-col>
    </v-row>
    <!-- fin de texto principal -->

    <!-- inicio de carrusel -->
    <v-carousel height="440" :show-arrows="false" hide-delimiter-background light>

      <v-carousel-item>
      <!-- inicio de tarjeta de alertas -->
        <v-card flat elevation="5" class="card-height my-3 mx-6">
        <v-row no-gutters>

          <!-- inicio de header de tarjeta -->
          <v-col class="ltl-card-header-alert std-border-top-radius">
            <v-col cols="12" class="ltl-card-header-height pa-2 d-flex align-center justify-center std-border-top-radius">
              <h4 class="ltl-card-text-header ma-0">Configurar alertas</h4>
            </v-col>
          </v-col>
          <!-- fin de header de tarjeta -->

          <!-- inicio de icono de tarjeta -->
          <v-col cols="12"
                 class="ltl-card-icon-container mx-auto my-3 pa-0 d-flex align-center justify-center icon-container">
            <img src="../assets/OnboardingAlertConfig.svg" alt="#"/>
          </v-col>
          <!-- fin de icono de tarjeta -->

          <!-- inicio de texto de tarjeta -->
          <v-col class="d-flex align-center justify-center mx-2 mb-3 px-6 full-height">
            <p class="card-text-2 text-container unselectable">Selecciona los canales que prefieras para recibir alertas</p>
          </v-col>
          <!-- fin de texto de tarjeta -->

        </v-row>
        </v-card>
      <!-- fin de tarjeta de alertas -->
      </v-carousel-item>

      <v-carousel-item>
      <!-- inicio de tarjeta de vacas -->
        <v-card flat elevation="5" class="card-height my-3 mx-6">
      <v-row no-gutters>

        <!-- inicio de header de tarjeta -->
        <v-col class="ltl-card-header-cows std-border-top-radius">
          <v-col cols="12" class="ltl-card-header-height pa-2 d-flex align-center justify-center std-border-top-radius">
            <h4 class="ltl-card-text-header ma-0">Registrar mis vacas</h4>
          </v-col>
        </v-col>
        <!-- fin de header de tarjeta -->

        <!-- inicio de icono de tarjeta -->
        <v-col cols="12"
               class="ltl-card-icon-container mx-auto my-3 pa-0 d-flex align-center justify-center icon-container">
          <img src="../assets/OnboardingCowRegistry.svg" alt="#"/>
        </v-col>
        <!-- fin de icono de tarjeta -->

        <!-- inicio de texto de tarjeta -->
        <v-col class="d-flex align-center justify-center mx-2 mb-3 px-6 full-height">
          <p class="card-text-2 text-container unselectable">Registra los datos de cada una de tus vacas</p>
        </v-col>
        <!-- fin de texto de tarjeta -->

      </v-row>
        </v-card>
      <!-- fin de tarjeta de vacas -->
      </v-carousel-item>

      <v-carousel-item>
      <!-- inicio de tarjeta de potreros -->
        <v-card flat elevation="5" class="card-height my-3 mx-6">
      <v-row no-gutters>

        <!-- inicio de header de tarjeta -->
        <v-col class="ltl-card-header-stall std-border-top-radius">
          <v-col cols="12" class="ltl-card-header-height pa-2 d-flex align-center justify-center std-border-top-radius">
            <h4 class="ltl-card-text-header ma-0">Organizar mis potreros</h4>
          </v-col>
        </v-col>
        <!-- fin de header de tarjeta -->

        <!-- inicio de icono de tarjeta -->
        <v-col cols="12"
               class="ltl-card-icon-container mx-auto my-3 pa-0 d-flex align-center justify-center icon-container">
          <img src="../assets/OnboardingStallOrg.svg" alt="#"/>
        </v-col>
        <!-- fin de icono de tarjeta -->

        <!-- inicio de texto de tarjeta -->
        <v-col class="d-flex align-center justify-center mx-2 mb-3 px-6 full-height">
          <p class="card-text-2 text-container unselectable">Creá los potreros digitales que tiene para sus vacas</p>
        </v-col>
        <!-- fin de texto de tarjeta -->

      </v-row>
        </v-card>
      <!-- fin de tarjeta de potreros -->
      </v-carousel-item>

      <v-carousel-item>
      <!-- inicio de tarjeta de rancho -->
        <v-card flat elevation="5" class="card-height my-3 mx-6">
          <v-row no-gutters>

            <!-- inicio de header de tarjeta -->
            <v-col class="ltl-card-header-ranch std-border-top-radius">
              <v-col cols="12" class="ltl-card-header-height pa-2 d-flex align-center justify-center std-border-top-radius">
                <h4 class="ltl-card-text-header ma-0">Configurar mi rancho</h4>
              </v-col>
            </v-col>
            <!-- fin de header de tarjeta -->

            <!-- inicio de icono de tarjeta -->
            <v-col cols="12"
                   class="ltl-card-icon-container mx-auto my-3 pa-0 d-flex align-center justify-center icon-container">
              <img src="../assets/OnboardingRanchConfig.svg" alt="#"/>
            </v-col>
            <!-- fin de icono de tarjeta -->

            <!-- inicio de texto de tarjeta -->
            <v-col class="d-flex align-center justify-center mx-2 mb-3 px-6 full-height">
              <p class="card-text-2 text-container unselectable">Completa los datos de tu perfil, rancho y programa de vacunaciones</p>
            </v-col>
            <!-- fin de texto de tarjeta -->

          </v-row>
        </v-card>
      <!-- fin de tarjeta de rancho -->
      </v-carousel-item>
    </v-carousel>
    <!-- fin de carrusel -->


    <!-- inicio de boton omitir -->
    <v-row cols="12" class="align-center" justify="center" no-gutters>
      <v-col cols="4" class="d-flex align-center justify-center">
        <v-btn text cols="12"  class="my-3 d-flex std-text-grey">
          Omitir paso
        </v-btn>
      </v-col>
    </v-row>
    <!-- fin de boton omitir -->

    </v-container>
</template>
  
  <script>
  import ChangeRanch from '@/components/ChangeRanch.vue';
  export default {
    name: 'MobileComponents',
      data () {
        return {
        }
    },
    components: {
      ChangeRanch
    },
    computed: {
    },
    methods: {
    },
    mounted () {
    }
  };
  </script>
  
  <style lang="css">
    @import '../style/MobileDashboardOnboarding.css';
    @import '../style/BaseStyle.css';
  </style>